export default __webpack_public_path__ + "6b3c7b709b8eaf82788c5c406769f5b3.png";